angular.module('component-spinner-button', [])
    .directive('ctSpinnerButton', dfSpinnerButtonDirective);

function dfSpinnerButtonDirective() {
    return {
        restrict: 'A',
        link: postLink
    };

    function postLink(scope, element, attrs) {
        var $icon = element.find('[icon]');

        element
            .addClass('ct-loader-button')
            .prepend(angular.element(require('./spinner.html')));

        scope.$watch(attrs.ctSpinnerButton, function(value) {
            if (value) {
                $icon.hide();
                element.addClass('loading');
            } else {
                $icon.show();
                element.removeClass('loading');
            }
        });
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/component-spinner-button/component-spinner-button.js
 ** module id = 79
 ** module chunks = 1
 **/